var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-trigger"},[_c('FixedTable',{staticClass:"container2",attrs:{"title":_vm.tableTitle,"isOp":false,"dataKey":"id","tableData":_vm.tableData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a57d1a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TradeDetail/components/OrderSearch/OrderSearch.vue
// module id = KF17
// module chunks = 2